import { useEffect, useRef, useState } from "react";
import { ConfirmDialog } from "@/components/dialogs/ConfirmDialog";
import { NoticeDialog } from "@/components/dialogs/NoticeDialog";
import { registerDialogHost } from "@/lib/dialogs";

// Mounted once. Shows one confirm or one notice at a time; later requests wait their turn so none is lost.
export function DialogHost() {
  const [confirm, setConfirm] = useState(null);
  const [notice, setNotice] = useState(null);
  const queue = useRef([]);
  const showing = useRef(false);

  const next = () => {
    const item = queue.current.shift();
    showing.current = !!item;
    if (!item) return;
    if (item.type === "confirm") setConfirm(item.opts); else setNotice(item.opts);
  };
  const push = (type, opts) => { queue.current.push({ type, opts }); if (!showing.current) next(); };

  useEffect(() => registerDialogHost({ confirm: (o) => push("confirm", o), notice: (o) => push("notice", o) }), []); // eslint-disable-line react-hooks/exhaustive-deps

  const answer = (value) => { confirm?.resolve(value); setConfirm(null); setTimeout(next, 0); };
  const closeNotice = () => { setNotice(null); setTimeout(next, 0); };

  return (
    <>
      {confirm && <ConfirmDialog open kind={confirm.kind} title={confirm.title} description={confirm.description} confirmLabel={confirm.confirmLabel}
        cancelLabel={confirm.cancelLabel} onConfirm={() => answer(true)} onOpenChange={(o) => { if (!o) answer(false); }} />}
      {notice && <NoticeDialog open {...notice} onOpenChange={(o) => { if (!o) closeNotice(); }} />}
    </>
  );
}
